import { Injectable } from '@angular/core';
import { SelectOptions, CheckboxOptions } from 'models';
import { PATTERN, RESTRICT } from 'utils/constants';

@Injectable({ providedIn: 'root' })

export class DataService {

  constructor() { }

  userId;
  otp; // temporary OTP bypass
  user; // User Info stored at login.

  formObject; // used to store data from selected row on edit;

  areaSwmData; // used in Area's SWM Edit/View;

  statusOptions = [
    { value: 1, option: 'Active' },
    { value: 0, option: 'In-Active' }
  ];

  weekDays: SelectOptions[] = [
    { value: 1, option: 'Monday' },
    { value: 2, option: 'Tuesday' },
    { value: 3, option: 'Wednesday' },
    { value: 4, option: 'Thursday' },
    { value: 5, option: 'Friday' },
    { value: 6, option: 'Saturday' },
    { value: 7, option: 'Sunday' },
  ];

  // Used in gtl
  genderOptions: SelectOptions[] = [
    { value: 'Gents', option: 'Gents' },
    { value: 'Gents & Ladies', option: 'Gents & Ladies' },
    { value: 'Gents, Ladies & Transgender', option: 'Gents, Ladies & Transgender' },
  ];

  individualGenderOptions: SelectOptions[] = [
    { value: 1, option: 'Gents' },
    { value: 2, option: 'Ladies' },
    { value: 3, option: 'Other' },
    { value: 4, option: 'Gents & Ladies' },
    { value: 5, option: 'Gents, Ladies & Other' },
  ];


  fieldTypes: SelectOptions[] = [
    { value: 'readOnly', option: 'Read Only' },
    { value: 'text', option: 'Input' },
    { value: 'select', option: 'Select Options' },
    { value: 'radio', option: 'Radio' },
    { value: 'date', option: 'Date' },
    { value: 'toggle', option: 'Yes/No' },
    { value: 'selectMultiple', option: 'Select Multiple' },
    { value: 'checkbox', option: 'Checkbox' },
    { value: 'textarea', option: 'Input(Text Area)' },
    { value: 'attachment', option: 'File Attachment' },
  ];
  fileTypes: SelectOptions[] = [
    { value: 'image/*', option: 'Image' },
    { value: '.pdf', option: 'PDF' },
    { value: '.doc,.docx', option: 'Word Document' },
    { value: '.xls,.xlsx', option: 'Excel Document' },
    { value: '.csv', option: 'CSV Files' },
    { value: '.ppt,.pptx', option: 'Power Point Document' },
    { value: 'video/*', option: 'Video' },
  ];

  validationOptions: SelectOptions[] = [
    { value: 'required', option: 'Required' },
    { value: 'pattern', option: 'Pattern' },
    { value: 'minLength', option: 'Minimum Length' },
    { value: 'maxLength', option: 'Maximum Length' }
  ];

  patternOptions: SelectOptions[] = [
    { value: PATTERN.MOBILE, option: 'Mobile' },
    { value: PATTERN.EMAIL, option: 'Email' },
    { value: PATTERN.AADHAAR, option: 'Aadhaar Number' },
    { value: PATTERN.PAN, option: 'PAN' },
    { value: PATTERN.TAN, option: 'TAN' },
    { value: PATTERN.GST, option: 'GST' },
    { value: PATTERN.CIN, option: 'CIN' },
    { value: PATTERN.DIN, option: 'DIN' },
    { value: PATTERN.WEBSITE, option: 'Web Url' },
    { value: 'other', option: 'Other' }
  ];

  sizeOptions: SelectOptions[] = [
    { value: '2', option: 'Extra Small (2)' },
    { value: '3', option: 'Small (3)' },
    { value: '4', option: 'Medium (4)' },
    { value: '6', option: 'Large (6)' },
    { value: '8', option: 'Extra Large (8)' },
    { value: '12', option: 'Full Width (12)' },
  ];

  inputTypeOptions: SelectOptions[] = [
    { value: RESTRICT.TEXT, option: 'Text' },
    { value: RESTRICT.CHAR, option: 'Character Only' },
    { value: RESTRICT.NUMBER, option: 'Number Only' },
    { value: RESTRICT.ALPHANUM, option: 'Alpha-Numeric' },
    { value: RESTRICT.AMOUNT, option: 'Amount (in Rs.)' },
    { value: RESTRICT.DECIMAL, option: 'Decimal/Float' },
    { value: RESTRICT.PWD, option: 'Password' },
  ];

  formTypeOptions: SelectOptions[] = [
    { value: 'area', option: 'Area' },
    { value: 'ward', option: 'Ward' },
    { value: 'rwa', option: 'RWA/Bodies' },
    { value: 'sanitation', option: 'Sanitation' },
    { value: 'infrastructure', option: 'City Infra' },
    { value: 'swm-infra', option: 'SWM Infra' },
    { value: 'bwg', option: 'Bulk Waste Generator' },
    { value: 'other', option: 'Others' },
  ];
  toiletCategories: SelectOptions[] = [
    { value: 'ptb', option: 'Public Toilet' },
    { value: 'ctp', option: 'Community Toilet' },
    { value: 'uri', option: 'Urinal Only' },
  ];
  fundingSource: SelectOptions[] = [
    { value: 1, option: 'SBM(Urban)' },
    // { value: 2, option: 'Smartcities' },
    { value: 3, option: 'Other' },
  ];
  maintenceBy: SelectOptions[] = [
    { value: 'ULB', option: 'ULB' },
    { value: 'Other', option: 'Private/NGO' },
  ];
  locationNear: SelectOptions[] = [
    { value: 'ptb', option: 'Restaurant' },
    { value: 'ctp', option: 'Petrol Pump' },
    { value: 'uri', option: 'Urinal OnlyOthers' },
  ];
  projectStatus: SelectOptions[] = [
    { value: 1, option: 'Tendering In Progress' },
    { value: 2, option: 'Tender Awarded ' },
    { value: 3, option: 'Under Construction' },
    { value: 4, option: 'Constructed' },
  ];
  toiletAssociations: SelectOptions[] = [
    { value: 'public', option: 'Public' },
    { value: 'community', option: 'Community' },
    { value: 'sulabh', option: 'Sulabh Toilet' },
    { value: 'market', option: 'Market' },
    { value: 'mall', option: 'Malls' },
    { value: 'fuel', option: 'Fuel Station(Petrol Pumps/CNG Station)' },
    { value: 'rail', option: 'Railway Station' },
    { value: 'bus', option: 'Bus Stand' },
    { value: 'metro', option: 'Metro Station' },
    { value: 'govt', option: 'Govt. Hospital' },
    { value: 'other', option: 'Other' },
  ];

  grievancePriority: SelectOptions[] = [
    { value: '1', option: 'Low' },
    { value: '2', option: 'Normal' },
    { value: '3', option: 'High' },
    { value: '4', option: 'Urgent' }
  ];
  grievanceStatus: SelectOptions[] = [
    { value: '1', option: 'Pending' },
    { value: '2', option: 'Inprocess' },
    { value: '3', option: 'Resolved' },
    { value: '4', option: 'Invalied' },
    { value: '5', option: 'Raised' },
  ];
  grievanceCategories: SelectOptions[] = [
    { value: 'Covid-19', option: 'Covid-19' },
    { value: 'Garbage', option: 'Garbage' },
    { value: 'Swachhta', option: 'Swachhta' }
  ];
  fieldDisableOption: SelectOptions[] = [
    { value: true, option: 'Yes' },
    { value: false, option: 'No' }
  ];
}
